const DomainListColumn = [
  {
    title: 'Domains',
    dataIndex: 'domain',
    slot: 'domain',
    width: 250,
  },
  {
    title: 'OK',
    dataIndex: 'healthStatusOk',
    slot: 'healthStatusOk',
    width: 100,
  },
  {
    title: 'Warning',
    dataIndex: 'healthStatusWarning',
    slot: 'healthStatusWarning',
    width: 100,
  },
  {
    title: 'Critical',
    dataIndex: 'healthStatusCritical',
    slot: 'healthStatusCritical',
    width: 100,
  },
  {
    title: 'Continuous Monitoring',
    dataIndex: 'healthStatusContinuousMonitoring',
    slot: 'healthStatusContinuousMonitoring',
    width: 100,
  },
  {
    title: 'Committed Polling Interval',
    dataIndex: 'committedPollingInterval',
    slot: 'committedPollingInterval',
    width: 200,
    sorter: (a, b) => a.committedPollingInterval.localeCompare(b.committedPollingInterval),
  },
  {
    title: 'Variable Polling Interval',
    dataIndex: 'variablePollingInterval',
    slot: 'variablePollingInterval',
    width: 200,
    sorter: (a, b) => a.variablePollingInterval.localeCompare(b.variablePollingInterval),
  },
  {
    title: '# Of Committed URLs',
    dataIndex: 'monitoringTypeCommitted',
    width: 200,
    sorter: (a, b) => a.committedURLs - b.committedURLs,
  },
  {
    title: '# Of Variable URLs',
    dataIndex: 'monitoringTypeVariable',
    width: 200,
    sorter: (a, b) => a.variableURLs - b.variableURLs,
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation',
  },
];

export { DomainListColumn };
